import axiosInstance from "../../../utils/axiosConfig";
import React, { useState } from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { BiErrorCircle } from "react-icons/bi";
import { TailSpin } from "react-loader-spinner";
import { API_URL } from "../../../constant";
import History from "./History";
import CtaLink, {
  buildCtaLink,
  CtaLinkState,
  emptyCtaLink,
  validateCtaLink,
} from "../../../components/CtaLink";

const Emergency = ({ setEmergencyModal, setSuccessModal }: any) => {
  const [screen, setScreen] = useState<string>("New");
  const [error, setError] = useState<string>("");

  const [topic, setTopic] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [success, setSuccess] = useState<string>("");
  const [message, setMessage] = useState<string>("");
  const [isChecked, setIsChecked] = useState(false);
  const [date, setDate] = useState<string>("");
  const [time, setTime] = useState<string>("");
  const [link, setLink] = useState<CtaLinkState>(emptyCtaLink);
  const currentDate = new Date().toISOString().split("T")[0];
  const currentTime = new Date().toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  const validate = (
    message: string,
    isChecked: boolean,
    date: string,
    time: string,
    topic: string
  ) => {
    if (!message) {
      setError("Kindly add the push message");
      setTimeout(() => {
        setError("");
      }, 3000);
      return false;
    }
    if (!topic) {
      setError("Kindly add the topic of the message");
      setTimeout(() => {
        setError("");
      }, 3000);
      return false;
    }

    if (isChecked && !date) {
      setError("Kindly add the scheduled date");
      setTimeout(() => {
        setError("");
      }, 3000);
      return false;
    }
    if (isChecked && !time) {
      setError("Kindly add the scheduled time");
      setTimeout(() => {
        setError("");
      }, 3000);
      return false;
    }
    setError("");
    return true;
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!validate(message, isChecked, date, time, topic)) {
      return;
    }

    const linkError = validateCtaLink(link);
    if (linkError) {
      setError(linkError);
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }

    if (!loading) {
      setLoading(true);
      const data: { [key: string]: any } = {
        type: "emergency",
        topic: topic,
        message: message,
      };
      if (date && time) {
        const combinedDateTime = new Date(`${date}T${time}`);
        data.schedule = {
          isScheduled: true,
          date: combinedDateTime.toISOString(),
        };
      } else {
        const scheduleDate = new Date();
        scheduleDate.setMinutes(scheduleDate.getMinutes() + 1);
        const isoDate = scheduleDate.toISOString();
        data.schedule = {
          isScheduled: false,
          date: isoDate,
        };
      }
      const ctaLink = buildCtaLink(link);
      if (ctaLink) {
        data.link = ctaLink;
      }
      //   console.log(data);
      axiosInstance
        .post(`${API_URL}api/notifications/advanced`, data)
        .then((r: any) => {
          setLoading(false);
          setTopic("");
          setMessage("");
          setLink(emptyCtaLink);

          if (isChecked) {
            setSuccess("Emergency Alert scheduled successfully");
          } else {
            setSuccess("Emergency Alert sent successfully");
          }
          setTimeout(() => {
            setSuccess("");
            setEmergencyModal(false);
            setSuccessModal(true);
          }, 3000);
        })
        .catch((e: any) => {
          setError(e.response.data.message);
          setLoading(false);
          setTimeout(() => {
            setError("");
          }, 6000);
          console.log(e.response.data.message);
        });
    }
  };

  return (
    <div className="fixed inset-0 flex font-manrope justify-center items-start overflow-auto pt-16 pb-16  bg-black bg-opacity-80 pr-10 backdrop-blur-sm">
      <div
        className={
          " w-11/12 lgss:w-2/5 transition-all p-6 ease-in duration-1000  rounded-xl bg-[#1F1F1F] "
        }
      >
        <div className="flex   justify-between items-center">
          <h4 className="font-bold text-[20px] font-sora text-white">
            Emergency Alert
          </h4>
          <h4
            onClick={() => setEmergencyModal((prev: any) => !prev)}
            className="text-[#78C2F7] text-[14px] font-medium cursor-pointer"
          >
            Close
          </h4>
        </div>
        <div className="w-full flex mt-4 justify-start items-center gap-4">
          <h4
            onClick={() => setScreen("New")}
            className={
              screen === "New"
                ? " text-[16px] text-gray-400 cursor-pointer font-bold "
                : " text-[14px] text-[#333F48] cursor-pointer font-bold "
            }
          >
            New
          </h4>
          <h4
            onClick={() => setScreen("History")}
            className={
              screen === "History"
                ? " text-[16px] text-gray-400  cursor-pointer font-bold "
                : " text-[14px] text-[#333F48] cursor-pointer font-bold "
            }
          >
            History
          </h4>
        </div>
        {screen === "New" ? (
          <form className="w-full mt-6" onSubmit={handleSubmit}>
            {success && (
              <div className="bg-green-600 w-full text-white  text-[16px] rounded-xl justify-start items-center gap-4 flex h-[60px] px-2 font-bold mt-4 mb-4">
                <AiOutlineCheckCircle className="text-3xl text-white" />
                {success}
              </div>
            )}
            <div className="w-full ">
              <label className="text-[14px] font-bold text-white">Topic</label>
              <input
                type="text"
                value={topic}
                onChange={(e) => setTopic(e.target.value)}
                placeholder="Say something cool"
                className="w-full mt-2 text-[15px] tracking-wider placeholder:text-[15px]  text-[#A0A9AD] bg-[#1C2227] px-4 outline-none h-[48px] rounded-xl border border-[#141414]"
              />
            </div>
            <div className="w-full mt-6">
              <label className="text-[14px] font-bold text-white">
                Message
              </label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type here..."
                className="w-full mt-2 text-[15px] tracking-wider placeholder:text-[15px]  text-[#A0A9AD] pt-2 bg-[#1C2227] px-4 outline-none h-[80px] rounded-xl border border-[#141414]"
              />
            </div>
            <div className="flex  justify-start mt-6 w-full items-center gap-2">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                className="h-[16px] w-[16px]"
              />
              <h4 className="text-[14px] font-bold text-white">
                Schedule message
              </h4>
            </div>
            {isChecked && (
              <div className="w-full flex justify-center gap-4 items-center mt-6">
                <div className="w-[55%]">
                  <label className="text-[13px] font-bold text-white">
                    Select Date
                  </label>
                  <input
                    type="date"
                    value={date}
                    min={currentDate}
                    onChange={(e) => setDate(e.target.value)}
                    className="w-full mt-2 text-[15px] tracking-wider placeholder:text-[15px]  text-[#A0A9AD] bg-[#1C2227] px-4 outline-none h-[48px] rounded-xl border border-[#141414]"
                  />
                </div>
                <div className="w-[45%]">
                  <label
                    htmlFor=""
                    className="text-[13px] font-bold text-white"
                  >
                    Select Time
                  </label>
                  <input
                    type="time"
                    min={currentTime}
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                    className=" w-full mt-2 text-[15px] tracking-wider placeholder:text-[15px]  text-[#A0A9AD] bg-[#1C2227] px-4 outline-none h-[48px] rounded-xl border border-[#141414]"
                  />
                </div>
              </div>
            )}
            <CtaLink value={link} onChange={setLink} />
            {error && (
              <div className="bg-red-600 text-white  text-[12px] rounded-xl justify-start items-center gap-2 flex h-[50px] px-2 font-bold mt-4">
                <BiErrorCircle className="text-xl" />
                {error}
              </div>
            )}
            <button
              type="submit"
              className="w-full h-[46px] flex justify-center items-center font-manrope font-medium rounded-xl text-white bg-secondary_button mt-6"
            >
              {loading ? (
                <TailSpin color="#FFFFFF" height={30} width={30} />
              ) : (
                "Send "
              )}
            </button>
          </form>
        ) : screen === "History" ? (
          <History />
        ) : null}
      </div>
    </div>
  );
};

export default Emergency;
